import { CanDeactivateFn } from '@angular/router'
import { Store } from '@ngxs/store'
import { inject } from '@angular/core'
import type ResidentComponent from '../../app/pages/resident/resident.component'
import { ResidentState } from '../../store/resident/resident.state'
import { RouteName } from '../enums/route-name.enum'

export const residentDeactivateGuard: CanDeactivateFn<ResidentComponent> = (
  component,
  currentRoute,
  currentState,
  nextState
) => {
  if (
    nextState.url.startsWith('/' + RouteName.Login) ||
    nextState.url.startsWith('/' + RouteName.LoginRpm)
  ) {
    return true
  }
  const store = inject(Store)
  const viewMode = store.selectSnapshot(ResidentState.viewMode)
  if (viewMode !== 'right') {
    return true
  }
  component.showHasUnsavedChangesPopup(nextState.url)
  return false
}
